"use strict";

exports.__esModule = true;
exports.tilesColumn = exports.tiles = void 0;

var _styledComponents = require("styled-components");

var tiles = function tiles(flow) {
  if (flow === void 0) {
    flow = "row wrap";
  }

  return (0, _styledComponents.css)(["display:flex;flex-flow:", ";"], flow);
};

exports.tiles = tiles;

var tilesColumn = function tilesColumn(columns) {
  if (columns === void 0) {
    columns = 1;
  }

  return (0, _styledComponents.css)(["padding:0 10px;width:calc(100% / ", ");"], columns);
};

exports.tilesColumn = tilesColumn;